<template>
  <WsMain></WsMain>
</template>

<script>
export default {};
</script>

<style>
</style>